import { render, staticRenderFns } from "./logisnotify.vue?vue&type=template&id=291e18a6&scoped=true"
import script from "./logisnotify.vue?vue&type=script&lang=js"
export * from "./logisnotify.vue?vue&type=script&lang=js"
import style0 from "./logisnotify.vue?vue&type=style&index=0&id=291e18a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291e18a6",
  null
  
)

export default component.exports